export const ORDER_STATUS = {
  PENDING: 1,
  PROCESSING: 2,
  ARRIVED: 3,
  COMPLETED: 4,
  REFUSED: 5,
  CANCELED: 6,
  FAILED: 7,
  SHIPPING: 8,
};

export const ORDER_STATUS_MAP = {
  1: { label: "Pending", key: "pending", color: "gold", text: "Pending" },
  2: { label: "Processing", key: "processing", color: "blue", text: "Processing" },
  3: { label: "Arrived", key: "arrived", color: "cyan", text: "Arrived" },
  4: { label: "Completed", key: "completed", color: "green", text: "Completed" },
  5: { label: "Refused", key: "refused", color: "volcano", text: "Refused" },
  6: { label: "Canceled", key: "canceled", color: "default", text: "Canceled" },
  7: { label: "Failed", key: "failed", color: "magenta", text: "Failed" },
  8: { label: "Shipping", key: "shipping", color: "purple", text: "Shipping" },
};

export const STATUS_STRING_TO_ID = {
  pending: 1,
  processing: 2,
  arrived: 3,
  completed: 4,
  refused: 5,
  canceled: 6,
  cancelled: 6,
  failed: 7,
  shipping: 8,
};

export const SHIPPING_COMPANY = {
  IMILE: 1,
  VNLIN: 2,
  ARAMEX: 3,
};

export const SHIPPING_COMPANY_MAP = {
  1: { name: "iMile", color: "blue" },
  2: { name: "Vnlin", color: "geekblue" },
  3: { name: "Aramex", color: "orange" },
};

export const getOrderStatusInfo = (status, t) => {
  if (status === null || status === undefined || status === "") {
    return { label: t ? t("table.common.na", "N/A") : "N/A", color: "default" };
  }
  const numericStatus =
    typeof status === "string"
      ? STATUS_STRING_TO_ID[status.toLowerCase()] || Number(status)
      : status;
  const info = ORDER_STATUS_MAP[numericStatus];
  if (!info) {
    return {
      label: String(status),
      color: "default",
    };
  }
  return {
    ...info,
    label: t && info.key ? t(`order.status.${info.key}`, info.label) : info.label,
  };
};

export const getShippingCompanyInfo = (companyId) => {
  if (companyId === null || companyId === undefined || companyId === "") {
    return null;
  }
  const numericId = Number(companyId);
  return (
    SHIPPING_COMPANY_MAP[numericId] || {
      name: `Company ${companyId}`,
      color: "default",
    }
  );
};
